module.exports = __webpack_public_path__ + "img/left-arrow.829e80e4.svg";